import { hideLaunchEditOnMobile } from '~commonInfra/utils/MobileHelper';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { ILaunchWebAuthoringAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { editWorkbookDraft } from '../actions/EditWorkbookAction';

export const EditWorkbookAction: IEntityAction<IContentInfo<'workbook'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editWorkbook_action,
  isVisible: () => !hideLaunchEditOnMobile(),
  isClickable: (availableActions: ILaunchWebAuthoringAction, targetItems: IContentInfo[]) => {
    return targetItems && targetItems.length === 1 && !!(availableActions && availableActions.launchWebAuthoring);
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
   return editWorkbookDraft(targetItems[0], 'ActionMenu_EditWorkbook');
  }
};
